import { render, staticRenderFns } from "./LoginAttempts.vue?vue&type=template&id=0874210c"
import script from "./LoginAttempts.vue?vue&type=script&lang=js"
export * from "./LoginAttempts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports